export const ASSESSING = 'assessing';
export const BOOKMARKING = 'bookmarking';
export const CLASSIFYING = 'classifying';
export const COMMENTING = 'commenting';
export const DESCRIBING = 'describing';
export const EDITING = 'editing';
export const HIGHLIGHTING = 'highlighting';
export const IDENTIFYING = 'identifying';
export const LINKING = 'linking';
export const MODERATING = 'moderating';
export const QUESTIONING = 'questioning';
export const REPLYING = 'replying';
export const TAGGING = 'tagging';
export const IS_NEW_COMMENT = 'isNewComment';
export const COMMENT_PUBLISH_EVENTS = {
  create: 'commentCreated',
  delete: 'commentDeleted',
  resolved: 'commentResolved',
  read: 'commentRead',
};

export const ALL_MOTIVATIONS = [
  ASSESSING,
  BOOKMARKING,
  CLASSIFYING,
  COMMENTING,
  DESCRIBING,
  EDITING,
  IDENTIFYING,
  HIGHLIGHTING,
  LINKING,
  MODERATING,
  QUESTIONING,
  REPLYING,
  TAGGING,
];
